import styled from "styled-components";

import { minMedia } from "container/global.styles";

import SharedStyles from "styles/shared.styles";

const Container = styled.div`
    ${(props) => (props.withColor ? "padding" : "margin")}: 25px 0 25px;

    ${minMedia.desktop`
        text-align: center;
        ${(props) => (props.withColor ? "padding" : "margin")}: 70px 0 70px;
   `};
`;

const TextContainer = styled.div`
    text-align: ${(props) => props.textAlignMobile ?? "left"};
    margin-bottom: 15px;

    &:last-child {
        margin-bottom: 0;
    }

    ${minMedia.desktop`
        margin-bottom: 30px;
        text-align: ${(props) => props.textAlignDesktop ?? "center"};
    `};
`;

const CarouselContainer = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 0px;

    &:last-child {
        margin-bottom: 0;
    }

    ${minMedia.desktop`
        flex-direction: row;
    `};
`;

const More = styled(SharedStyles.TextButton)`
    align-items: center;
    display: flex;
    height: 50px;
    justify-content: center;
    width: 100%;
`;

const TileWrapper = styled.a`
    display: block;
    height: 100%;
    margin: 15px 0 0;
    text-align: left;
    width: 100%;

    &:first-child {
        margin-top: 0;
    }

    ${minMedia.desktop`
        margin: 0 20px;

        &:first-child {
            margin-left: 0;
         }

        &:last-child {
            margin-right: 0;
        }
    `};
`;

const BtnWrapper = styled.div`
    margin: 25px 0;

    ${minMedia.desktop`
        margin: 0 auto;
        width: 350px;
    `};
`;

export default {
    Container,
    TextContainer,
    CarouselContainer,
    More,
    TileWrapper,
    BtnWrapper
};
